// Countdown Timer Manager
class CountdownTimerManager {
  constructor() {
    this.timers = new Map();
    this.intervals = new Map(); // Separate Map für Intervals
    this.init();
    this.setupCartUpdateListener();
  }

  init() {
    // Bei DOM-Änderungen Timer neu initialisieren
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.querySelector) {
              const timer = node.querySelector('#countdown-timer');
              if (timer || node.id === 'countdown-timer') {
                setTimeout(() => this.initializeTimer(), 100);
              }
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Initial Timer starten
    setTimeout(() => this.initializeTimer(), 100);
  }

  setupCartUpdateListener() {
    // Event Listener für Cart-Updates
    document.addEventListener('cart:item-added', () => {
      this.resetTimer();
    });

    // Zusätzlich für andere Cart-Events
    document.addEventListener('cart:updated', () => {
      this.resetTimer();
    });

    // Für Bulk-Add Operationen
    document.addEventListener('bulk:item-added', () => {
      this.resetTimer();
    });

    // Für fetch-basierte Cart-Updates überwachen
    this.interceptCartRequests();
  }

  interceptCartRequests() {
    const originalFetch = window.fetch;
    window.fetch = (...args) => {
      const [url, options] = args;
      
      // Überprüfen ob es ein Cart-Request ist
      if (url.includes('/cart/') || url.includes('cart.json') || url.includes('cart/add')) {
        return originalFetch(...args).then(response => {
          // Nur bei erfolgreichen Add-to-Cart Requests
          if (response.ok && (url.includes('cart/add') || (options?.method === 'POST' && url.includes('cart')))) {
            setTimeout(() => this.resetTimer(), 100);
          }
          return response;
        });
      }
      
      return originalFetch(...args);
    };
  }

  resetTimer() {
    // console.log('Timer wird zurückgesetzt');
    // Timer-Startzeit zurücksetzen
    const storageKey = 'countdown_start_time';
    sessionStorage.removeItem(storageKey);
    
    // Alle laufenden Timer stoppen
    this.cleanup();
    
    // Neuen Timer starten
    setTimeout(() => {
      this.initializeTimer();
    }, 200);
  }

  initializeTimer() {
    const timer = document.getElementById('countdown-timer');
    if (!timer) {
      // console.log('Timer Element nicht gefunden');
      return;
    }

    // console.log('Timer wird initialisiert');
    const timerId = 'free-shipping-countdown';
    
    // Bestehenden Timer/Interval stoppen
    if (this.intervals.has(timerId)) {
      clearInterval(this.intervals.get(timerId));
      this.intervals.delete(timerId);
    }

    const storageKey = 'countdown_start_time';
    let startTime = sessionStorage.getItem(storageKey);
    
    if (!startTime) {
      startTime = Date.now();
      sessionStorage.setItem(storageKey, startTime);
      // console.log('Neue Startzeit gesetzt:', new Date(startTime));
    } else {
      startTime = parseInt(startTime);
      // console.log('Vorhandene Startzeit:', new Date(startTime));
    }

    // Timer-Dauer aus data-attribute oder Standard 10 Minuten
    const initialDuration = (parseInt(timer.dataset.countdown) || 600) * 1000;
    // console.log('Timer-Dauer:', initialDuration / 1000, 'Sekunden');

    const updateTimer = () => {
      const currentTimer = document.getElementById('countdown-timer');
      if (!currentTimer) {
        // console.log('Timer Element verschwunden - stoppe Updates');
        this.intervals.delete(timerId);
        return;
      }
      
      const elapsed = Date.now() - startTime;
      const timeLeft = Math.max(0, Math.floor((initialDuration - elapsed) / 1000));
      
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;
      currentTimer.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;

      // console.log('Timer Update:', `${minutes}:${seconds.toString().padStart(2, '0')}`, 'timeLeft:', timeLeft);

      // Timer-Container finden für Styling
      const timerContainer = currentTimer.closest('#countdown-container') || 
                            currentTimer.closest('.od-bg-successLight') ||
                            currentTimer.parentElement;
                            
      if (timerContainer) {
        // Wenn unter 1 Minute (60 Sekunden)
        if (timeLeft > 0 && timeLeft < 60) {
          timerContainer.classList.add('!od-bg-errorLight', '!od-text-error');
          // console.log('Timer kritisch - rote Warnung aktiviert');
        } else {
          timerContainer.classList.remove('!od-bg-errorLight', '!od-text-error');
        }
      }

      if (timeLeft <= 0) {
        // console.log('Timer abgelaufen');
        currentTimer.textContent = '0:00';
        timerContainer.classList.add('!od-bg-errorLight', '!od-text-error');
        // Inhalt des countdown-content Elements ändern
        document.getElementById('countdown-progress').style.display = 'none';
        document.getElementById('countdown-ended').style.display = 'block';

        clearInterval(this.intervals.get(timerId));
        this.intervals.delete(timerId);
        // sessionStorage.removeItem(storageKey); // Optional: Timer-Zeit behalten
        return;
      }
      else {
                document.getElementById('countdown-progress').style.display = 'block';
        document.getElementById('countdown-ended').style.display = 'none';
      }
    };

    // Sofort einmal ausführen
    updateTimer();
    
    // Dann jede Sekunde wiederholen
    const intervalId = setInterval(updateTimer, 1000);
    this.intervals.set(timerId, intervalId);
    
    // console.log('Timer Interval gestartet:', intervalId);
  }

  cleanup() {
    // console.log('Timer Cleanup');
    // Alle Timeouts stoppen
    this.timers.forEach(timerId => clearTimeout(timerId));
    this.timers.clear();
    
    // Alle Intervals stoppen
    this.intervals.forEach(intervalId => clearInterval(intervalId));
    this.intervals.clear();
  }
}

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  onCartUpdate() {
    // Nach Cart-Update auch die Prio-Box Visibility aktualisieren
    super.onCartUpdate();
    
    // Timer bei Cart-Update zurücksetzen
    if (window.countdownManager) {
      window.countdownManager.resetTimer();
    }
    
    // Cart-Drawer Parent finden und alle Updates ausführen
    const cartDrawer = this.closest('cart-drawer');
    if (cartDrawer) {
      setTimeout(() => {
        cartDrawer.updatePrioBoxVisibility();
      }, 200);
      
      // Lieferdatum mit mehreren Versuchen aktualisieren
      setTimeout(() => {
        cartDrawer.updateDeliveryDates();
      }, 400);
      
      setTimeout(() => {
        cartDrawer.updateDeliveryDates();
      }, 800);
    }
  }

  // Überschreiben der updateQuantity Methode um alle Updates zu triggern
  updateQuantity(line, quantity, name, type) {
    // console.log('CartDrawerItems updateQuantity called');
    super.updateQuantity(line, quantity, name, type);
    
    // Nach Quantity-Update alle Updates ausführen
    const cartDrawer = this.closest('cart-drawer');
    if (cartDrawer) {
      setTimeout(() => {
        cartDrawer.updatePrioBoxVisibility();
      }, 300);
      
      // Mehrere Versuche für Lieferdatum
      setTimeout(() => {
        // console.log('First delivery date update attempt after quantity change');
        cartDrawer.updateDeliveryDates();
      }, 500);
      
      setTimeout(() => {
        // console.log('Second delivery date update attempt after quantity change');
        cartDrawer.updateDeliveryDates();
      }, 1000);
    }
  }

  // Überschreiben der onChange Methode für alle Cart-Änderungen
  onChange(event) {
    // console.log('CartDrawerItems onChange called');
    super.onChange(event);
    
    // Nach jeder Änderung alle Updates ausführen
    const cartDrawer = this.closest('cart-drawer');
    if (cartDrawer) {
      setTimeout(() => {
        cartDrawer.updatePrioBoxVisibility();
      }, 300);
      
      // Mehrere Versuche für Lieferdatum
      setTimeout(() => {
        // console.log('First delivery date update attempt after onChange');
        cartDrawer.updateDeliveryDates();
      }, 500);
      
      setTimeout(() => {
        // console.log('Second delivery date update attempt after onChange');
        cartDrawer.updateDeliveryDates();
      }, 1000);
    }
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    
    // Prio-Shipping Setup
    this.prioVariantId = 51243508302171;
    this.prioButtonProcessing = false;
    this.setupPrioButton();
    
    // Timer Manager initialisieren
    this.initializeCountdownManager();
    
    // Event Listener für alle Cart-Updates
    this.setupCartUpdateListeners();
  }

  // Erweiterte Cart-Update Listener
  setupCartUpdateListeners() {
    // Listener für verschiedene Cart-Events
    document.addEventListener('cart:changed', () => {
      setTimeout(() => {
        this.updatePrioBoxVisibility();
      }, 200);
      
      setTimeout(() => {
        // console.log('Delivery date update after cart:changed');
        this.updateDeliveryDates();
      }, 500);
    });

    // MutationObserver für DOM-Änderungen im Cart-Drawer
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.target.closest('#CartDrawer')) {
          // Wenn Cart-Items sich ändern, Lieferdatum aktualisieren
          if (mutation.target.closest('.cart-items') || mutation.target.id === 'CartDrawer-CartItems') {
            setTimeout(() => {
              // console.log('Delivery date update after DOM mutation');
              this.updateDeliveryDates();
            }, 300);
          }
          
          // Wenn delivery-dates Element hinzugefügt wird
          if (mutation.target.id === 'delivery-dates' || mutation.target.querySelector('#delivery-dates')) {
            setTimeout(() => {
              // console.log('Delivery date update after delivery-dates element added');
              this.updateDeliveryDates();
            }, 100);
          }
        }
      });
    });

    // Observer auf den Cart-Drawer anwenden
    observer.observe(this, {
      childList: true,
      subtree: true
    });

    // Listener für AJAX Cart-Updates
    const originalFetch = window.fetch;
    window.fetch = (...args) => {
      const [url, options] = args;
      
      // Bei Cart-Updates alle Updates ausführen
      if (url.includes('/cart/') && options?.method === 'POST') {
        return originalFetch(...args).then(response => {
          if (response.ok) {
            setTimeout(() => {
              this.updatePrioBoxVisibility();
            }, 300);
            
            setTimeout(() => {
              // console.log('Delivery date update after fetch cart update');
              this.updateDeliveryDates();
            }, 600);
          }
          return response;
        });
      }
      
      return originalFetch(...args);
    };
  }

  initializeCountdownManager() {
    // Timer Manager nur einmal global initialisieren
    if (!window.countdownManager) {
      window.countdownManager = new CountdownTimerManager();
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  // Prio-Button Setup mit Event Delegation
  setupPrioButton() {
    this.addEventListener('click', async (e) => {
      if (e.target && e.target.id === 'prio-shipping-btn') {
        e.preventDefault();
        await this.handlePrioButtonClick();
      }
    });
  }

  // Prio-Button Click Handler
  async handlePrioButtonClick() {
    if (this.prioButtonProcessing) {
      // console.log('Prio button already processing, skipping...');
      return;
    }

    this.prioButtonProcessing = true;
    // console.log('Prio button clicked');

    try {
      // Aktuellen Cart prüfen
      const cart = await this.fetchCart();
      const isPrioInCart = this.isPrioProductInCart(cart);

      if (!isPrioInCart) {
        // console.log('Adding prio product...');
        const success = await this.addPrioProduct();
        
        if (success) {
          // Timer zurücksetzen bei erfolgreichem Add
          if (window.countdownManager) {
            window.countdownManager.resetTimer();
          }
          
          // Alles in einem Zug neu rendern
          await this.refreshCartDrawer();
          await this.updateCartIconBubble();
        }
      } else {
        // console.log('Prio product already in cart');
      }
    } catch (error) {
      console.error('Error in prio button handler:', error);
    } finally {
      setTimeout(() => {
        this.prioButtonProcessing = false;
      }, 500);
    }
  }

  // Cart-Daten holen
  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  // Prüfen ob Prio-Produkt im Cart ist
  isPrioProductInCart(cart) {
    return cart.items.some(item => 
      parseInt(item.variant_id) === parseInt(this.prioVariantId)
    );
  }

  // Prio-Produkt hinzufügen
  async addPrioProduct() {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: this.prioVariantId,
          quantity: 1,
        })
      });

      const result = await response.json();
      // console.log('Add response:', result);

      if (response.ok) {
        // console.log('Prio product added successfully');
        return true;
      } else {
        // console.error('Failed to add prio product:', result);
        return false;
      }
    } catch (error) {
      console.error('Error adding prio product:', error);
      return false;
    }
  }

  // Cart-Drawer komplett neu laden
  async refreshCartDrawer() {
    try {
      const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
      const html = await response.text();
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, 'text/html');
      
      // Drawer Inner komplett ersetzen
      const currentDrawerInner = this.querySelector('.drawer__inner');
      const newDrawerInner = newDoc.querySelector('.drawer__inner');
      
      if (currentDrawerInner && newDrawerInner) {
        currentDrawerInner.replaceWith(newDrawerInner);
        // console.log('Cart drawer refreshed');
        
        // Nach dem Refresh alle Updates ausführen
        setTimeout(() => {
          this.updatePrioBoxVisibility();
          this.updateDeliveryDates(); // Wichtig: Nach Refresh das Lieferdatum aktualisieren
          
          // Timer nach dem Refresh neu initialisieren
          if (window.countdownManager) {
            window.countdownManager.initializeTimer();
          }
        }, 200);
      }
    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
    }
  }

  // Verbesserte Methode: Lieferdatum aktualisieren mit robuster Retry-Logik
  updateDeliveryDates() {
    // console.log('updateDeliveryDates called');
    
    const tryUpdate = (attempt = 1) => {
      const deliveryContainer = this.querySelector('#delivery-dates');
      if (!deliveryContainer) {
        // console.log(`Delivery dates container not found (attempt ${attempt})`);
        if (attempt < 5) {
          setTimeout(() => tryUpdate(attempt + 1), 200 * attempt);
        }
        return;
      }

      const dateElements = deliveryContainer.querySelectorAll('span[data-date]');
      if (dateElements.length === 0) {
        // console.log(`No delivery date elements found (attempt ${attempt})`);
        if (attempt < 5) {
          setTimeout(() => tryUpdate(attempt + 1), 200 * attempt);
        }
        return;
      }

      // console.log(`Updating delivery dates... Found ${dateElements.length} date elements (attempt ${attempt})`);

      // Alle Datums-Spans verstecken
      dateElements.forEach(span => {
        span.classList.add('od-hidden');
      });

      // Spätestes Datum finden
      let latestDate = null;
      let latestElement = null;

      dateElements.forEach(span => {
        const dateString = span.getAttribute('data-date');
        if (!dateString) return;

        // console.log('Processing date string:', dateString);

        // Datum parsen (Format kann variieren: "04.09." oder "04.09")
        const cleanDate = dateString.replace(/\.$/, ''); // Punkt am Ende entfernen
        const dateParts = cleanDate.split('.');
        
        if (dateParts.length >= 2) {
          const day = parseInt(dateParts[0]);
          const month = parseInt(dateParts[1]);
          
          // Jahr bestimmen - wenn Monat kleiner als aktueller Monat, nächstes Jahr nehmen
          const currentDate = new Date();
          const currentYear = currentDate.getFullYear();
          const currentMonth = currentDate.getMonth() + 1; // getMonth() ist 0-basiert
          
          let year = currentYear;
          if (month < currentMonth || (month === currentMonth && day < currentDate.getDate())) {
            year = currentYear + 1;
          }
          
          const date = new Date(year, month - 1, day); // Monat ist 0-basiert
          
          // console.log('Parsed date:', dateString, '→', date.toDateString());
          
          if (!latestDate || date > latestDate) {
            latestDate = date;
            latestElement = span;
            // console.log('New latest date found:', date.toDateString());
          }
        } else {
          // console.log('Could not parse date:', dateString);
        }
      });

      // Spätestes Datum anzeigen
      if (latestElement) {
        latestElement.classList.remove('od-hidden');
        // console.log('Latest delivery date shown:', latestElement.getAttribute('data-date'), latestElement.textContent);
      } else {
        // console.log('No valid delivery date found');
      }
    };

    // Ersten Versuch starten
    tryUpdate();
  }

  // Prio Box Sichtbarkeit aktualisieren
  async updatePrioBoxVisibility() {
    const prioBox = this.querySelector('#prio-shipping');

    if (!prioBox) {
      // console.log('Prio box not found, checking globally...');
      // Falls im aktuellen Drawer nicht gefunden, global suchen
      const globalPrioBox = document.querySelector('#prio-shipping');
      if (globalPrioBox) {
        // console.log('Found global prio box');
      }
      return;
    }

    try {
      const cart = await this.fetchCart();
      const isPrioInCart = this.isPrioProductInCart(cart);

      // console.log('Cart items:', cart.items.length, 'Prio in cart:', isPrioInCart);

      if (isPrioInCart) {
        prioBox.classList.add('od-hidden');
        // console.log('Prio box hidden - product in cart');

        // Prio-Info mit Retry-Logik suchen
        this.updatePrioInfo(true);
      } else {
        prioBox.classList.remove('od-hidden');
        // console.log('Prio box shown - product not in cart');
        
        // Prio-Info mit Retry-Logik suchen
        this.updatePrioInfo(false);
      }
    } catch (error) {
      console.error('Error updating prio box visibility:', error);
    }
  }

  // Neue Methode: Prio-Info mit Retry-Logik aktualisieren
  updatePrioInfo(showInfo) {
    // console.log('Updating prio info, show:', showInfo);
    
    const updateInfo = () => {
      const prioInfo = this.querySelector('#prio-info');
      if (prioInfo) {
        if (showInfo) {
          prioInfo.classList.remove('od-hidden');
          // console.log('Prio info shown');
        } else {
          prioInfo.classList.add('od-hidden');
          // console.log('Prio info hidden');
        }
        return true;
      } else {
        // console.log('Prio info element not found');
      }
      return false;
    };

    // Sofort versuchen
    if (!updateInfo()) {
      // Falls nicht gefunden, mit kleinem Delay wiederholen
      setTimeout(() => {
        if (!updateInfo()) {
          // Noch einmal nach längerem Delay
          setTimeout(() => {
            updateInfo();
          }, 300);
        }
      }, 100);
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    
    // Beim Öffnen alle Updates ausführen
    this.updatePrioBoxVisibility();
    this.updateDeliveryDates(); // Lieferdatum beim Öffnen aktualisieren
    
    // Timer beim Öffnen initialisieren
    setTimeout(() => {
      if (window.countdownManager) {
        window.countdownManager.initializeTimer();
      }
    }, 200);
    
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // Cleanup beim Entfernen des Elements
  disconnectedCallback() {
    if (window.countdownManager) {
      window.countdownManager.cleanup();
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

// Timer Manager initialisieren wenn DOM bereit ist
document.addEventListener('DOMContentLoaded', () => {
  if (!window.countdownManager) {
    window.countdownManager = new CountdownTimerManager();
  }
});

// Cleanup bei page unload
window.addEventListener('beforeunload', () => {
  if (window.countdownManager) {
    window.countdownManager.cleanup();
  }
});
